<template>
<div>
    <v-btn
        class="mx-1"
        text
        @click="handleProfileIconClick"
        v-if="$route.name != 'Profile'">
        <v-icon left>mdi-account</v-icon>
        <span>{{loggedInUser ? loggedInUser.name : null}}</span>
    </v-btn>
    <v-menu offset-y>
        <template v-slot:activator="{on}">
            <v-btn
                small
                class="mx-1"
                v-on="on"
                icon>
                <v-icon>
                    mdi-apps
                </v-icon>
            </v-btn>
        </template>
        <ModuleDialog ref="moduleDialog" />
    </v-menu>
    <v-menu offset-y>
        <template v-slot:activator="{on}">
            <v-btn
                small
                icon
                class="mx-1"
                v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
        </template>
        <v-list dense>
            <v-list-item @click="openPasswordChangeDialog" link>
                <v-list-item-icon>
                    <v-icon>mdi-key</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ $t('change_password_user') }}</v-list-item-title>
            </v-list-item>
            <v-list-item link @click="localeDialog = true">
                <v-list-item-icon>
                    <v-icon>mdi-translate</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ $t("language") }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="logout" link>
                <v-list-item-icon>
                    <v-icon>mdi-logout</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ $t('logout_user') }}</v-list-item-title>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item @click="$vuetify.theme.dark = !$vuetify.theme.dark" link>
                <v-list-item-icon>
                    <v-icon>
                        {{ $vuetify.theme.dark ? 'mdi-white-balance-sunny' : 'mdi-brightness-3' }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ $vuetify.theme.dark ? $t('change_mode') : $t('change_mode_dark') }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
    <PasswordChangeDialog ref="passwordChangeDialog" />
    <v-dialog
        v-model="localeDialog"
        max-width="350">
        <v-card>
            <v-card-title>{{$t("language")}}</v-card-title>
            <v-card-subtitle>{{$t("change_language")}}</v-card-subtitle>
            <v-card-text>
                <v-select
                    :label="$t('language')"
                    v-model="locale"
                    :items="locales"
                    item-text="name"
                    item-value="locale"
                    outlined
                    dense
                    hide-details="auto">
                </v-select>
            </v-card-text>
            <v-card-actions>
                <v-btn color="primary" @click="onLocaleChange">
                    {{$t("btn_confirm")}}
                </v-btn>
                <v-btn text @click="localeDialog = false">
                    {{$t("cancel_btn")}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import ModuleDialog from '@/components/common/ModuleDialog';
import PasswordChangeDialog from '@/components/administration/PasswordChangeDialog';
import i18n from './../../plugins/i18n'
import {
    mapActions, mapState
} from 'vuex';
export default {
    name: "ToolbarMenuRight",
    components: {
        ModuleDialog,
        PasswordChangeDialog
    },
    data() {
        return {
            localeDialog: false,
            locale: "en"
        }
    },
    watch: {
        localeDialog() {
            this.locale = i18n.locale;
        }
    },
    computed: {
        ...mapState("authentication", ["loggedInUser"]),
        locales() {
            return [
                { name: "English", locale: "en", rtl: false },
                { name: "عربي", locale: "ar", rtl: true },
            ]
        }
    },
    methods: {
        ...mapActions('authentication', ["logout"]),
        openPasswordChangeDialog() {
            this.$refs.passwordChangeDialog.open();
        },
        handleProfileIconClick() {
            this.$router.push({
                name: 'Profile'
            })
        },
        onLocaleChange() {
            let rtl = this.locales.find(each => each.locale == this.locale).rtl;
            let locale = this.locale;

            this.$vuetify.rtl = rtl;
            i18n.locale = locale;
            this.localeDialog = false;
            localStorage.setItem("locale", locale);
            localStorage.setItem("rtl", rtl)
        }
    }
}
</script>
